import styled from "styled-components";

const ListContainer = styled.div`
  margin-top: 1rem;
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  grid-gap: 1rem;
`;

export default ListContainer;
